import React, { Component } from 'react'
import classnames from 'classnames'

class HeroSpinner extends Component {
  constructor(props) {
    super(props)
    this.state = { visible: false, active: true }
    this.updateTimeout = null
  }

  componentWillReceiveProps(nextProps) {
    const {
      preventScroll: nextPreventScroll,
      index: nextHeroIndex,
      forceUpdateHash: nextForceUpdateHash,
    } = nextProps 
    const {
      preventScroll: prevPreventScroll,
      index: prevHeroIndex,
      forceUpdateHash: prevForceUpdateHash,
    } = this.props 

    const isIndexChange = nextHeroIndex !== prevHeroIndex
    const isScrollChange = nextPreventScroll !== prevPreventScroll
    const isForceUpdate = nextForceUpdateHash !== prevForceUpdateHash

    if (isIndexChange || isScrollChange || isForceUpdate) {
      this.setState({
        active: true,
        visible: true
      })
      
      clearTimeout(this.updateTimeout)
      
      this.updateTimeout = setTimeout(() => {
        this.setState({
          active: false
        })
      }, 80)
    }
  }

  componentWillUnmount() {
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout)
      this.updateTimeout = null
    }
  }

  render() {
    const { active, visible } = this.state
    return (
      <div className={classnames({'hero__circle-container--transition': active, 'hero__circle-container--visible': visible}, 'hero__circle-container')}>
        <div className="hero__circle-noclip"></div>
        <div className="hero__circle-wrapper" data-anim="base wrapper">
          <div className="hero__circle" data-anim="base left"></div>
          <div className="hero__circle" data-anim="base right"></div>
        </div>
      </div>
    )
  }
}

export default HeroSpinner


// WEBPACK FOOTER //
// ./src/components/hero/hero-spinner.js